exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sendEmailToSellerForm__container___26g3B {\n  padding: 20px 0; }\n", ""]);

// exports
exports.locals = {
	"container": "sendEmailToSellerForm__container___26g3B"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdDetailsPage/AdDetailsPageMobile/EmailDealerModal/EmailDealerForm/sendEmailToSellerForm.scss
// module id = 4515
// module chunks = 6